import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiRoutes } from './apiroutes';
import { ChatToken, Chats, NewChat, SentDocumentsList } from '../models/chat';
import { AuthService } from 'src/app/services/auth.service';
import { webSocket } from 'rxjs/webSocket';
@Injectable({
    providedIn: 'root',
})
export class ChatService {
    base_url = ApiRoutes.ChatToken;
    socket_url = ApiRoutes.SocketUrl;
    documents_url = ApiRoutes.SentDocumentsUrl;
    notificationStatus_url = ApiRoutes.NotificationStatusUrl;

    current_user = '';
    chatToken: ChatToken;
    wsSubject$;
    chatMessages: Chats[] = [];
    newChat: NewChat;
    notifications = [];
    originalTitle: string = 'ARCON | Reimagining Container Logistics';
    blinkingInterval: any;
    noAccessToChat: boolean = false;
    unreadChatCount: number = 0;

    constructor(private http: HttpClient) { }

    initiateChat(token) {
        console.log('Initiate Chat ------>');
        this.getClientToken(token).subscribe((res) => {
            this.chatToken = res;
            const url = this.socket_url + '?token=' + this.chatToken.token;
            this.wsSubject$ = webSocket({
                url: url,
            });
            // console.log(this.chatToken);
        });
        return this.wsSubject$;
    }


    getClientToken(token: string) {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + token,
            }),
        };
        return this.http.post<ChatToken>(this.base_url, {}, httpOptions);
    }

    getSentDocuments(thread_id: string, page: number) {
        return this.http.get<SentDocumentsList>(this.documents_url + thread_id + '/attached_documents/?page=' + page);
    }

    updateNotificationStatus(id: string) {
        return this.http.put(this.notificationStatus_url + id + '/mark_as_read/', {});
    }

    getUserAndGroupList(page_size = 10, search = '', is_transactional = true) {
        let url = `${ApiRoutes.Chat}thread/search/`;
        let urlObj = new URL(url);
        urlObj.searchParams.append('search', String(search));
        urlObj.searchParams.append('page_size', String(page_size));
        urlObj.searchParams.append('is_transactional', String(is_transactional));
        // urlObj.searchParams.append('page', String(page));

        return this.http.get(String(urlObj));
    }

    setDocumentTitleOnNewMessage() {
        this.blinkingInterval = setInterval(() => {
            document.title =
                document.title === this.originalTitle
                    ? 'New Message Received!'
                    : this.originalTitle;
        }, 1000);
    }

    resetDocumentTitle() {
        clearInterval(this.blinkingInterval);
        document.title = this.originalTitle;
        this.blinkingInterval = null;
    }
}
